angular.module('zc.zenclerkS')

  .component('zcsProjectUserActivity', {
    templateUrl: '/templates/zenclerk_s/directives/project_user_activity/user_activity.html',
    bindings: {
      projects: '<'
    },
    controllerAs: 'vm',
    controller: zcsProjectUserActivityController
  });

zcsProjectUserActivityController.$inject = ['$scope', '$q', 'MongoSession'];
function zcsProjectUserActivityController($scope, $q, MongoSession) {
  const vm = this;

  vm.$onInit = () => {
    vm.toggleUserList = toggleUserList;

    $scope.$watchCollection('vm.projects', (newval, oldval) => {
      if(newval) getSessionsForAllProjects();
    });
  };

  function toggleUserList(project) {
    if(!project._showUserList) {
      project._showUserList = true;
    } else {
      project._showUserList = false;
    }
  }

  function getSessionsForUser(user) {
    return MongoSession.find({
      apikey: 'emin-zcs',
      opened_at: { $gte: moment().subtract(1, 'months').toDate() },
      'cookie_segment.user_id': user.id.toString()
    }).then(sessions => {
      user.sessions = sessions;
      user.combinedDwell = _.sumBy(user.sessions, d => d.dwell / (60 * 1000));
      if(!user.sessions.length) {
        user.lastViewed = null;
      } else {
        user.lastViewed = _.max(_.map(user.sessions, 'closed_at'));
      }
    });
  }

  function getSessionsForAllProjects() {
    _.each(vm.projects, project => {
      let promises = _.map(project.users, getSessionsForUser);
      $q.all(promises).then(result => {
        $scope.$broadcast('gotSessions', project);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/project_user_activity/user_activity.directive.js